import { apiClient } from '../../../utilities/apiClient';

// Read the post author's public profile. Phase B doesn't ship a /users/public
// endpoint yet — when it lands, swap the call below. Until then we fall back
// to a stub that matches the legacy "dresez user" anon-user shape so the
// detail page renders without errors.
export const getUserDetails = async ({ userId, otherData = {} }) => {
  try {
    const res = await apiClient.get(`/users/public/${userId}`);
    return { ...res.data.user, otherData };
  } catch {
    return { id: userId, name: 'dresez user', otherData };
  }
};

// Create-or-return the conversation between two users for a given post.
// POST /conversations is idempotent on (senderId, receiverId) — the backend
// computes the chat id via the same chatIdGenerator semantics as the legacy
// client, so existing chats are surfaced.
export const createChat = ({ senderId, recieverId, postId }) => {
  void senderId; // sender comes from the auth cookie on the backend
  return apiClient
    .post('/conversations', { receiverId: recieverId, postId })
    .then((res) => res.data.conversation.id);
};
